export const CONDITIONS = 'conditions';

export const STATIC = 'Static';
export const DYNAMIC = 'Dynamic';
export const FORMULA = 'Formula';

export const CONDITION_TYPES = [
  {
    id: STATIC,
    name: 'Static',
  },
  {
    id: DYNAMIC,
    name: 'Dynamic',
  },
  {
    id: FORMULA,
    name: 'Formula',
  },
];

export const CONDITION_TYPE = 'type';
export const METRIC = 'metric';
export const OPERATOR = 'operator';
export const CALCULATION_TYPE = 'calculationType';
export const METRIC_VALUE_TYPE = 'metricValueType';
export const VALUE_TYPE = 'valueType';
export const GROUP_TYPE = 'groupType';
export const VALUE = 'value';
export const VALUE_FORMULA = 'valueFormula';
export const NAME = 'name';
export const PERCENT = 'percent';

export const PERIODS_COMPARE = 'PeriodsCompare';

export const PERCENTILE = 'Percentile';
export const WEIGHTED_AVERAGE = 'WeightedAverage';

export const AFFECTED_LEVEL_PART_HELPERS = {
  Affiliate: 'affiliates',
  Application: 'applications',
  Campaign: 'campaigns',
  PartnerCampaign: 'partner campaigns',
  AdSet: 'adSets',
  AggregatedPublisher: 'aggregated publishers',
  AggregatedPlacement: 'aggregated placements',
  Publisher: 'publishers',
  Placement: 'placements',
  PartnerAd: 'partner ads',
  Platform: 'platforms',
  RealCountry: 'real countries',
};

export const OPERATOR_PART_HELPERS = {
  1011: 'of the highest',
  1010: 'of the lowest',
};
export const METRIC_CREATIVE_STATUS = 'creativestatus';
